import { oktaConfig, redirectUri, issuer, clientId } from './index';

const oktaWidgetDefaultConfiguration = {
  baseUrl: oktaConfig.baseUrl,
  clientId,
  redirectUri,
  useClassicEngine: true,
  authParams: {
    issuer,
    pkce: true,
    display: `page`,
    responseType: 'code',
  },
};

export const oktaWidgetID = '#okta-widget-container';

export const oktaWidgetConfiguration = {
  ...oktaWidgetDefaultConfiguration,
  el: oktaWidgetID,
  i18n: {
    en: {
      'errors.E0000004': `The password or email you entered did not match our records. Please double-check and try again. For help logging in, click “Trouble logging in?” below.`,
      'primaryauth.username.tooltip': ' ',
      'primaryauth.title': 'Welcome to Tempus',
      'primaryauth.submit': 'Log in',
      'primaryauth.username.placeholder': 'Email',
      'error.username.required': 'Please input your email',
      'error.password.required': 'Please input your password',
      'error.auth.lockedOut': 'Your account is locked. Please contact your administrator.',
      'password.forgot.email.or.username.placeholder': 'Email',
      'password.forgot.email.or.username.tooltip': ' ',
      'oform.errorbanner.title': 'Please fill out all fields',
      forgotpassword: 'Forgot Password?',
      goback: 'Return to sign in',
    },
  },
  features: {
    router: true,
    rememberMe: true,
    showPasswordToggleOnSignInPage: true,
    selfServiceUnlock: false,
    registration: false,
    webauthn: true,
    // Used to enable the idp discovery feature on the widget.
    // REQUIRED for third-party SSO support
    idpDiscovery: true,
  },
  idpDiscovery: {
    requestContext: `${window.location.origin}?fromLogin=true${window.location.search.replace('?', '&')}`,
  },
};
